var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-eyewear-protection-panel-and-modal" },
    [
      _vm.isMobileOrTablet
        ? _c("rb-eyewear-protection-panel", {
            attrs: { "is-visible": _vm.isVisible },
            on: { closePanel: _vm.closeOverlay },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobileOrTablet
        ? _c("rb-eyewear-protection-modal", {
            attrs: { "is-visible": _vm.isVisible },
            on: { closeModal: _vm.closeOverlay },
            scopedSlots: _vm._u(
              [
                {
                  key: "modal-content",
                  fn: function () {
                    return [_c("rb-eyewear-protection-overlay-content")]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1806561183
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }